import React, { forwardRef, useState, useRef, useImperativeHandle } from "react";
import useForkRef from "@Util/hook/useForkRef";
import CyclePurchaseCancel from "./CyclePurchaseCancelDialog";

const CYCLE_PURCHASE_CANCEL_DIALOG = "cycle-purchase-cancel-dialog";

const CyclePurchaseCancelDialogBox = forwardRef((props, ref) => {
	const dialogRef = useRef(null);
	const combinedRef = useForkRef(ref, dialogRef);
	const [openDialog, setOpenDialog] = useState("");
	const [sourceData, setSourceData] = useState({});
	const refreshRef = useRef(null);

	// 刷新明細資料
	const doRefresh = () => {
		if (refreshRef.current && typeof refreshRef.current === "function") refreshRef.current();
	};

	const handleCloseDialog = () => {
		setOpenDialog(null);
		setSourceData(null);
		refreshRef.current = null;
	};

	useImperativeHandle(
		combinedRef,
		() => ({
			openCyclePurchaseCancelDialog: (targetData = {}, _refreshFn = () => {}) => {
				refreshRef.current = _refreshFn;
				setSourceData(targetData);
				setOpenDialog(CYCLE_PURCHASE_CANCEL_DIALOG);
			},
			closeDialog: () => handleCloseDialog(),
		}),
		// eslint-disable-next-line
		[openDialog, sourceData]
	);
	return (
		<React.Fragment>
			<CyclePurchaseCancel open={openDialog === CYCLE_PURCHASE_CANCEL_DIALOG} onClose={handleCloseDialog} sourceData={sourceData} refresh={doRefresh} />
		</React.Fragment>
	);
});

export default CyclePurchaseCancelDialogBox;
